import { render } from "./GenderRule.vue?vue&type=template&id=193c5082"
import script from "./GenderRule.vue?vue&type=script&lang=js"
export * from "./GenderRule.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__